import styled from "styled-components";

export const CardsMasonryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  column-gap: 20px;
`;

export const CardsMasonry = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  & > div {
    * {
      cursor: pointer;
    }
  }
`;

export const OverviewCardsTemplatesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  column-gap: 16px;

  & > div {
    height: 100%;
  }
`;
